import { combineReducers } from 'redux';
import type { Action } from 'state/actions';
import { batchWorkspaceShortcutCheatsheetBannerReducer } from 'state/workspaces/batch/shortcutCheatsheetBanner/shortcutCheatsheetBanner.reducer';

import { type BatchWorkspaceState } from './batch.model';
import { batchWorkspaceTabContentReducer } from './tabContent/tabContent.reducer';

export const batchWorkspaceReducer = combineReducers<BatchWorkspaceState, Action>({
  tabContent: batchWorkspaceTabContentReducer,
  shortcutCheatsheetBanner: batchWorkspaceShortcutCheatsheetBannerReducer,
});
